import { guid } from '../../../../../utils/guid'
import SYSTEM_DATA from '../../../../../data'
import translator from '../../../../../translate'
import {
  FormItemType,
  FormItemFilterAddMode,
} from '../../../../../form/props/form-item/default'

const FormItemActive = {
  id: guid().uid(),
  attribute: 'IsActive',
  label: translator._('general.active'),
  type: FormItemType.MENU,
  optionAttributeName: { label: 'label', value: 'value' },
  required: false,
  disabled: false,
  hidden: false,
  filterAddMode: FormItemFilterAddMode.SINGLE,
  options: () => {
    return SYSTEM_DATA.FILTER_OPTIONS.IsActive
  },
}

export default FormItemActive
